import { Injectable, OnInit, AfterViewInit, PLATFORM_ID, Inject } from "@angular/core";
import { isPlatformServer } from "@angular/common";

@Injectable()
export class AccordionBaseComponent implements OnInit, AfterViewInit {
    public expanded: boolean = false;
    _isPlatformServer: boolean = false;

    constructor(@Inject(PLATFORM_ID) public readonly platformId: string){

    }
    ngOnInit(): void {
        this._isPlatformServer = isPlatformServer(this.platformId);
    }

    ngAfterViewInit(): void {
        if(!this._isPlatformServer){
            const expandedItems = document.querySelectorAll('.pb-c-base-accordion dt.pb-c-base-accordion--expanded + dd') as NodeListOf<HTMLElement>;

            expandedItems.forEach((item: HTMLElement) => {
                item.style.display = 'block';
            });

            const dtItems = document.querySelectorAll('.pb-c-base-accordion dt') as NodeListOf<HTMLElement>;

            dtItems.forEach((dt: HTMLElement) => {
                // dt.removeAllListeners();
                dt.removeEventListener('click', handleClick, true);
                dt.addEventListener('click', handleClick, true);
            });

            function handleClick(event: Event) {
                (event.currentTarget as HTMLElement)?.classList.toggle('pb-c-base-accordion--expanded');
            }
        }
    }
    
}